export const unreadNotificationsCountQueryKey = ['notifications', 'unread-count'] as const;
export const notificationsListQueryKey = ['notifications', 'list'] as const;
